import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import AulaUserContext from './aulaUserContext';

// Protege rutas del Aula. requireAdmin exige rol Admin exacto. allowedRoles acepta una lista
// de roles válidos (ej. ['Admin', 'Supervisor'] para el panel admin, que Supervisor también
// puede entrar pero con vista acotada — ese recorte pasa dentro del propio AdminPanel).
export const AulaPrivateRoute = ({ component: Component, requireAdmin, allowedRoles, ...rest }) => {
    const { aulaAuth } = useContext(AulaUserContext);

    return (
        <Route
            {...rest}
            render={(props) => {
                if (!aulaAuth.token) return <Redirect to="/aula/login" />;
                if (requireAdmin && aulaAuth.rol !== 'Admin') return <Redirect to="/aula" />;
                if (allowedRoles && !allowedRoles.includes(aulaAuth.rol)) return <Redirect to="/aula" />;
                return <Component {...props} />;
            }}
        />
    );
};
